import { render } from "./training-type-table.vue?vue&type=template&id=b5d24a3c"
import script from "./training-type-table.vue?vue&type=script&lang=js"
export * from "./training-type-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__